import React from "react";
import { Reveal } from "./Reveal";
import { WHY_PEIL } from "../../data/content";

export const WhyPeil = () => (
  <section id="why-peil" className="relative py-24 md:py-40 border-t border-brand-line bg-brand-surface/40" data-testid="why-peil-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-[0.42fr_0.58fr] gap-12 lg:gap-20">
      <Reveal>
        <p className="overline mb-6">07 — Why Peil</p>
        <h2 className="font-display font-light text-4xl md:text-6xl tracking-tight text-brand-text leading-[1.02]">
          The reasons clients stay.
        </h2>
        <p className="mt-8 text-brand-soft font-light max-w-sm leading-relaxed">
          We are a preferred business partner — combining superior programmes,
          competitive pricing and effective post-training follow-up.
        </p>
      </Reveal>

      <div>
        {WHY_PEIL.map((w, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="flex items-baseline gap-6 md:gap-10 py-6 border-b border-brand-line group">
              <span className="font-display text-3xl md:text-4xl text-brand/70 font-light w-14 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-brand-text/90 text-lg md:text-2xl font-light group-hover:text-brand group-hover:translate-x-2 transition-all duration-400">
                {w}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyPeil;
